import React from 'react'
import { connect } from 'react-redux'
import { deleteProject } from '../../../../store/actions/projectActions';
function ProjectDeleteModal(props) {
    const { modalWidth, modalTitleStyle, modalInfoTextStyle, proid, coid,commons } = props;
    return (
        <div className="dynamicModalContainer">
            <div className="dynamicModalSm">
                <p style={modalTitleStyle}>Confirm delete {commons.project}?</p>
                <p style={modalTitleStyle}>Warning:</p>
                <p style={modalInfoTextStyle}>Please you must note that this will permenantly delete this {commons.project}.</p>
                <br />

                <div className="btn btn-danger btn-sm" style={{ float: "right", borderRadius: '7px' }} onClick={() => props.deleteProject(proid, coid)} >Confirm</div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        alu: state.alu,
        floor: state.floor,

        formLabelStyle: state.appControl.formLabelStyle,
        modalStyles: state.appControl.modalStyles,
        modalWidth: state.appControl.modalWidth,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,
        commons:state.commons,
        companyData: state.firestore.data.Company,

        userId: state.firebase.auth.uid,
        companyBriefingsData: state.firestore.data.CompanyBriefings,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        deleteProject: (proid, coid) => dispatch(deleteProject(proid, coid)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectDeleteModal)
